import { signInWithEmailAndPassword } from "firebase/auth";
import { FloatingBackButton } from "../components/FloatingBackButton";
import { firebaseAuth } from "../firebase";
import { FocusIdFunc, useNavigate } from "../utils";
import { routes } from "../routes";
import { FirebaseError } from "firebase/app";
import { useState } from "react";

export const EmailLogin = () => {
  const navigate = useNavigate();
  const [disabled, setDisabled] = useState(true);
  const [badEmail, setBadEmail] = useState(false);

  const onChange = () => {
    const email = (document.getElementById("email") as HTMLInputElement).value;
    const password = (document.getElementById("password") as HTMLInputElement)
      .value;
    if (!email || !password) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  };

  const login = async () => {
    try {
      const email = (document.getElementById("email") as HTMLInputElement)
        .value;
      const password = (document.getElementById("password") as HTMLInputElement)
        .value;
      const credential = await signInWithEmailAndPassword(
        firebaseAuth,
        email,
        password
      );
      if (credential.user) {
        navigate(routes.result);
      }
    } catch (error) {
      switch ((error as FirebaseError).code) {
        case "auth/user-not-found":
        case "auth/wrong-password":
        case "auth/weak-password":
          alert("이메일 혹은 비밀번호가 일치하지 않습니다.");
          return;
        case "auth/network-request-failed":
          alert("네트워크 연결에 실패 하였습니다.");
          return;
        case "auth/invalid-email":
          setBadEmail(true);
          return;
        case "auth/internal-error":
        default:
          alert("로그인에 실패하였습니다.");
          return;
      }
    }
  };

  return (
    <div className="form">
      <FloatingBackButton />
      <span className="header">이메일로 로그인</span>
      <input
        className="input-group"
        id="email"
        type="email"
        name="email"
        placeholder="이메일"
        onChange={() => {
          onChange();
          setBadEmail(false);
        }}
        onSubmit={() => FocusIdFunc("password")}
        onKeyDown={(e) => {
          if (e.key === "Enter") FocusIdFunc("password");
        }}
        style={
          badEmail
            ? {
                borderColor: "var(--caution)",
              }
            : undefined
        }
      />
      {badEmail && (
        <span className="input-error">잘못된 이메일 형식입니다.</span>
      )}
      <input
        id="password"
        className="input-group"
        type="password"
        name="password"
        placeholder="비밀번호"
        onChange={onChange}
        onSubmit={login}
        onKeyDown={(e) => {
          if (e.key === "Enter") login();
        }}
      />
      <button
        disabled={disabled}
        id="submit"
        className="submit primary"
        onClick={login}
      >
        로그인
      </button>
      <span
        style={{ marginTop: 20, textAlign: "center", color: "var(--gray-7)" }}
        onClick={() => navigate(routes.resetPassword)}
      >
        비밀번호 재설정
      </span>
    </div>
  );
};
